<template>
    <!-- Navigate to other page with to-->
    <div 
      v-if="to" 
      :class="[{'button':true}, icon ? 'button-'+icon : 'button-default']"
    >
      <router-link 
        :to="to"
      >
        <div v-if="icon">
            <i :class="[{'fa': true}, icon ? 'fa-'+icon:'']"></i> 
            <!-- &nbsp;{{input}} -->
            &nbsp;&nbsp; <slot></slot>
        </div>
        <div v-else>
            <slot></slot>
        </div>
      </router-link>
    </div>
    <!-- end of to navigator -->

    <!-- Navigate to other page with href-->
    <div 
      v-else-if="href"
      :class="[{'button':true}, icon ? 'button-'+icon : 'button-default']"
    >
      <a :href="href">
        <div v-if="icon">
          <i :class="[{'fa': true}, icon ? 'fa-'+icon:'']"></i> 
          <!-- &nbsp;{{input}} -->
          &nbsp;&nbsp; <slot></slot>
        </div>
        <div v-else>
            <slot></slot>
        </div>
      </a>
    </div>
    <!--  end of href navigator-->

    <!-- Using for submit only -->
    <div v-else>
      <button 
        @click="click"
        :class="[{'button':true}, icon ? 'button-'+icon : 'button-default']"
      >
        <div v-if="icon">
            <i :class="[{'fab': true}, icon ? 'fa-'+icon:'']"></i>
            <!-- &nbsp;{{input}} -->
            &nbsp;&nbsp; <slot></slot>
        </div>
        <div v-else>
            <slot></slot>
        </div>
      </button>
    </div>
    <!-- End of submit button -->

</template>

<script>
export default {
    props:{
      to:String,
      href:String,
      icon: String,
      click: Function
    }
}
</script>

<style>
@import "./Button.css";
</style>